"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuHistoryHolder = void 0;
var _core = require("core.ui-module_site-components");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getSessionStorage = () => {
  try {
    return window.opener && window.opener.document && window.opener.document.domain === window.document.domain ? window.opener.sessionStorage : sessionStorage;
    // eslint-disable-next-line no-empty
  } catch {}
  return sessionStorage;
};
const appStorage = getSessionStorage();

// eslint-disable-next-line import/prefer-default-export
class MenuHistoryHolder {
  static getHistory() {
    const history = appStorage.getItem(_MENU_HISTORY_KEY._);
    return history ? JSON.parse(history) : [];
  }
  static addHistory(location, menuItem) {
    const history = MenuHistoryHolder.getHistory();
    history.push({
      ...location,
      menuItem
    });
    appStorage.setItem(_MENU_HISTORY_KEY._, JSON.stringify(history));
    _core.PostMessage.postMessageCoreEvent(MenuHistoryHolder.MENU_HISTORY_ADD_MESSAGE_KEY, {
      menuItem
    });
  }
  static reset() {
    appStorage.removeItem(_MENU_HISTORY_KEY._);
    _core.PostMessage.postMessageCoreEvent(MenuHistoryHolder.MENU_HISTORY_RESET_MESSAGE_KEY, {});
  }
}
exports.MenuHistoryHolder = MenuHistoryHolder;
var _MENU_HISTORY_KEY = {
  _: 'menu.history.locations'
};
_defineProperty(MenuHistoryHolder, "MENU_HISTORY_ADD_MESSAGE_KEY", 'MenuHistoryHolder--add');
_defineProperty(MenuHistoryHolder, "MENU_HISTORY_RESET_MESSAGE_KEY", 'MenuHistoryHolder--reset');
//# sourceMappingURL=MenuHistoryHolder.js.map